(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ninurta-product-card"] && !Shopify.designMode) return;
  try {
    /* global ninurtaSyncBadge, ninurtaShowToast, ninurtaOpenDrawer */
(function () {
  'use strict';

  if (window._ninurtaCardJsLoaded) return;
  window._ninurtaCardJsLoaded = true;

  /* ── Single-variant Ajax add ──────────────────────────────────── */
  async function ninurtaQuickAdd(variantId, btn) {
    var origText = btn.textContent.trim();
    btn.disabled = true;
    btn.textContent = '…';

    try {
      var r = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/javascript'
        },
        body: JSON.stringify({ id: Number(variantId), quantity: 1 })
      });
      var data = await r.json();
      if (!r.ok) throw new Error(data.description || (anchorBtn.dataset.labelError || 'Hata!'));

      /* Optimistic badge update */
      if (typeof window.ninurtaUpdateCartBadge === 'function') {
        var b = document.getElementById('ninurta-cart-badge');
        var c = b ? parseInt(b.textContent || '0', 10) : 0;
        window.ninurtaUpdateCartBadge(c + 1);
      }
      window._ninurtaDrawerStale = true;

      /* Show toast */
      if (typeof window.ninurtaShowToast === 'function') {
        window.ninurtaShowToast({
          product_title:   btn.dataset.productTitle || data.product_title || '',
          featured_image:  { url: btn.dataset.productImage || '' },
          variant_title:   btn.dataset.productVariant || data.variant_title || ''
        });
      }

      btn.textContent = btn.dataset.labelAdded || '✓ Eklendi';
      setTimeout(function () {
        btn.textContent = origText;
        btn.disabled = false;
      }, 2000);

    } catch (err) {
      btn.textContent = btn.dataset.labelError || 'Hata!';
      setTimeout(function () {
        btn.textContent = origText;
        btn.disabled = false;
      }, 2000);
      console.error('[Ninurta QA]', err);
    }
  }

  /* ── Multi-variant popup ──────────────────────────────────────── */
  async function ninurtaOpenVariantPopup(handle, anchorBtn) {
    var origText = anchorBtn.textContent.trim();
    anchorBtn.disabled = true;
    anchorBtn.textContent = '…';

    try {
      var resp    = await fetch('/products/' + handle + '.js');
      var product = await resp.json();

      var popup  = document.getElementById('ninurta-qa-popup');
      var ptitle = document.getElementById('ninurta-popup-title');
      var pvars  = document.getElementById('ninurta-popup-variants');
      if (!popup || !ptitle || !pvars) return;

      ptitle.textContent = product.title;
      pvars.innerHTML = '';

      product.variants.forEach(function (variant) {
        var vbtn       = document.createElement('button');
        vbtn.type      = 'button';
        vbtn.className = 'variant-btn';
        var soldOutLabel = anchorBtn.dataset.labelSoldOut || 'Tükendi';
        vbtn.textContent = variant.title + (variant.available ? '' : ' — ' + soldOutLabel);
        vbtn.disabled    = !variant.available;
        vbtn.dataset.variantId      = variant.id;
        vbtn.dataset.productTitle   = product.title;
        vbtn.dataset.productVariant = variant.title;
        vbtn.dataset.productImage   = product.featured_image
          ? String(product.featured_image.src || product.featured_image).split('?')[0] + '?width=120'
          : '';
        pvars.appendChild(vbtn);
      });

      popup.style.display = 'block';
      requestAnimationFrame(function () {
        var rect   = anchorBtn.getBoundingClientRect();
        var popupH = popup.offsetHeight || 200;
        var top    = rect.top > popupH + 8
          ? rect.top - popupH - 8 + window.scrollY
          : rect.bottom + 8 + window.scrollY;
        var left   = Math.min(
          Math.max(rect.left + window.scrollX, 8),
          window.innerWidth - (popup.offsetWidth || 240) - 8
        );
        popup.style.top  = top  + 'px';
        popup.style.left = left + 'px';
      });

    } catch (err) {
      console.error('[Ninurta Popup]', err);
    } finally {
      anchorBtn.textContent = origText;
      anchorBtn.disabled    = false;
    }
  }

  /* ── Event delegation ─────────────────────────────────────────── */
  document.addEventListener('click', function (e) {
    var popup = document.getElementById('ninurta-qa-popup');

    /* Close popup on outside click */
    if (popup && popup.style.display !== 'none') {
      if (!e.target.closest('#ninurta-qa-popup') && !e.target.closest('.ninurta-quick-add-btn')) {
        popup.style.display = 'none';
      }
    }

    /* Variant button inside popup */
    var vbtn = e.target.closest('#ninurta-qa-popup .variant-btn');
    if (vbtn && !vbtn.disabled) {
      if (popup) popup.style.display = 'none';
      ninurtaQuickAdd(vbtn.dataset.variantId, vbtn);
      return;
    }

    /* Quick Add button on card */
    var btn = e.target.closest('.ninurta-quick-add-btn');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    e.stopPropagation();

    if (btn.dataset.single === '1') {
      ninurtaQuickAdd(btn.dataset.variantId, btn);
    } else {
      ninurtaOpenVariantPopup(btn.dataset.productHandle, btn);
    }
  });

  /* Close popup on Escape */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var popup = document.getElementById('ninurta-qa-popup');
      if (popup) popup.style.display = 'none';
    }
  });

  /* Reposition popup on resize */
  window.addEventListener('resize', function () {
    var popup = document.getElementById('ninurta-qa-popup');
    if (popup && popup.style.display !== 'none') popup.style.display = 'none';
  });

})();
  } catch(e) { console.error(e); }
})();

})();
